import React from 'react';

import { ClockCircleOutlined, PlayCircleOutlined, SyncOutlined } from '@ant-design/icons';
import { CoreEnums } from '@/utils/domain/constants';

const START_MODE_CONFIG = {
  [CoreEnums.ProcessStartMode.Instant]: {
    icon: <PlayCircleOutlined />,
    dataActive: true,
    className: 'ant-btn-icon',
  },
  [CoreEnums.ProcessStartMode.Automated]: {
    type: 'link',
    icon: <SyncOutlined />,
    disabled: true,
    className: 'ant-btn-icon',
  },
  [CoreEnums.ProcessStartMode.Scheduled]: {
    type: 'link',
    icon: <ClockCircleOutlined />,
    disabled: true,
    className: 'ant-btn-icon',
  },
};

const START_MODE_LABELS = {
  [CoreEnums.ProcessStartMode.Automated]: 'global.text.automated',
  [CoreEnums.ProcessStartMode.Scheduled]: 'global.text.scheduled',
};

export const getStartModeLabel = (startMode, formatMessage) => {
  if (!formatMessage || startMode === CoreEnums.ProcessStartMode.Instant) return undefined;
  const labelKey = START_MODE_LABELS[startMode];
  return labelKey ? formatMessage({ id: labelKey }) : undefined;
};

export const getStartModeConfig = (startMode, startModeLabel, onStartModeClick) => {
  const config = START_MODE_CONFIG[startMode];
  if (!config) return null;

  const buttonConfig = { ...config };

  if (startMode === CoreEnums.ProcessStartMode.Instant) {
    buttonConfig.onClick = onStartModeClick;
  } else {
    buttonConfig.children = startModeLabel;
  }

  return buttonConfig;
};

export const isBulkOperationsEnabled = (isBulkRequestCreationEnabled, startMode) => {
  return isBulkRequestCreationEnabled && startMode === CoreEnums.ProcessStartMode.Instant;
};
